// extracted by mini-css-extract-plugin
export default {"header":"Layout_header__ARV4A","content":"Layout_content__95Ydx"};